module.exports = __webpack_public_path__ + "img/ic-filter.7cf05456.svg";